import { NavLink } from "react-router-dom";
import { Home, BookOpen, Sparkles } from "lucide-react";

const items = [
  { to: "/", label: "Home", icon: Home, id: "mobile-nav-home", end: true },
  { to: "/faqs", label: "Library", icon: BookOpen, id: "mobile-nav-library" },
  { to: "/ask", label: "Ask AI", icon: Sparkles, id: "mobile-nav-ask" },
];

export const MobileNav = () => (
  <nav
    className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-[#0B0D10]/95 backdrop-blur-xl border-t border-[#27303E] pb-[env(safe-area-inset-bottom)]"
    data-testid="mobile-bottom-nav"
  >
    <div className="grid grid-cols-3 h-16">
      {items.map(({ to, label, icon: Icon, id, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          data-testid={id}
          className={({ isActive }) =>
            `relative flex flex-col items-center justify-center gap-1 font-mono text-[10px] uppercase tracking-widest transition-colors duration-200 active:scale-95 ${isActive ? "text-amber-500" : "text-slate-400"}`
          }
        >
          {({ isActive }) => (
            <>
              {isActive && <span className="absolute top-0 h-0.5 w-10 bg-amber-500" />}
              <Icon size={20} strokeWidth={isActive ? 2.5 : 2} />
              {label}
            </>
          )}
        </NavLink>
      ))}
    </div>
  </nav>
);
